import { render } from "./legacy.vue?vue&type=template&id=f4138c64"
import script from "./legacy.vue?vue&type=script&lang=js"
export * from "./legacy.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__